<template>
    <div>
      <!-- <div class="header">
          <span>证书名称</span>
          <el-button @click="addList">添加</el-button>
        </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="certificateName" label="证书名称" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.certificateName" placeholder="请输入"></el-input>
            </template>
        </el-table-column>
        <el-table-column prop="certificateNumber" label="证书号码" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.certificateNumber" placeholder="请输入"></el-input>
            </template>
        </el-table-column>
        <el-table-column prop="issueDate" label="发证日期" align="center">
             <template slot-scope="scope">
                <el-date-picker
                      v-model="scope.row.issueDate"
                      type="date"
                      placeholder="选择日期" value-format="YYYY-MM-DD">
                    </el-date-picker>
              </template>
        </el-table-column>
        <el-table-column prop="issuingAuthorityName" label="发证单位名称" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.issuingAuthorityName" placeholder="请输入"></el-input>
            </template>
        </el-table-column>
        <el-table-column prop="certificateType" label="证书类型" align="center">
            <template slot-scope="scope">
                <el-select v-model="scope.row.certificateType" placeholder="请选择">
                    <el-option v-for="item in typeOption" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
            </template>
        </el-table-column>
        <el-table-column prop="isPermanent" label="是否永久" align="center">
            <template slot-scope="scope">
                <el-radio-group v-model="scope.row.isPermanent">
                    <el-radio label="0">是</el-radio>
                    <el-radio label="1">否</el-radio>
                  </el-radio-group>
            </template>
        </el-table-column>
        <el-table-column prop="expiryDate" label="到期日期" align="center">
             <template slot-scope="scope">
                <el-date-picker
                      v-model="scope.row.expiryDate"
                      type="date"
                      placeholder="选择日期" value-format="YYYY-MM-DD">
                    </el-date-picker>
              </template>
        </el-table-column>
        <el-table-column prop="certificateFile" label="证书文件" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.certificateFile" placeholder="请输入"></el-input>
            </template>
        </el-table-column>
        <el-table-column prop="" label="删除" align="center" width="100">
            <template slot-scope="scope">
                <el-button type="text" text @click="delectData(scope.$index)">删除</el-button>
            </template>
        </el-table-column>
      </el-table> -->

      <el-dialog v-if="dialogFormVisible" custom-class="box-dialog" :visible.sync="dialogFormVisible" append-to-body="true" width="800px" height="500px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="资格证书信息">

          <el-form :model="vo" @submit.native.prevent>
             <div style="width:100%;" class="el-table el-table--fit el-table--border">
               <div class="el-table__body-wrapper">
                 <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                   <tbody>
                   	<tr>
                   		<td ref="tdlbl_证书名称" class="el-table__cell tdlbl tdw17" colspan="1">
                   			<span class="required">*</span>
                             <span v-field-lbl="'certificateName'" class="field">证书名称</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                   				<form-item ref="certificateName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入证书名称','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'证书名称','propName':'certificateName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.certificateName','option':[]}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   		<td ref="tdlbl_证书编号" class="el-table__cell tdlbl tdw17" colspan="1">
                   			<span class="required">*</span>
                             <span v-field-lbl="'certificateNumber'" class="field">证书编号</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                   				<form-item ref="certificateNumber" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入证书编号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'证书编号','propName':'certificateNumber','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.certificateNumber','option':[]}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   	</tr>
                   	<tr>
                   		<td ref="tdlbl_发证日期" class="el-table__cell tdlbl tdw17" colspan="1">
                   			<span class="required">*</span>
                             <span v-field-lbl="'issueDate'" class="field">发证日期</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                            <form-item ref="issueDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'出生年月','propName':'issueDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'issueDate','iconName':'rqxzk','model':'vo.issueDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   		<td ref="tdlbl_证书类型" class="el-table__cell tdlbl tdw17" colspan="1">
                   			<span class="required">*</span>
                             <span v-field-lbl="'certificateType'" class="field">证书类型</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                   				<form-item ref="certificateType" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入证书类型','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'证书类型','propName':'certificateType','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.certificateType','option':[]}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   	</tr>
                   	<tr>
                   		<td ref="tdlbl_发证单位名称" class="el-table__cell tdlbl tdw17" colspan="1">
                   			<span class="required">*</span>
                             <span v-field-lbl="'issuingAuthorityName'" class="field">发证单位名称</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                   				<form-item ref="issuingAuthorityName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入发证单位名称','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'发证单位名称','propName':'issuingAuthorityName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.issuingAuthorityName','option':[]}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   		<td ref="tdlbl_是否永久" class="el-table__cell tdlbl tdw17" colspan="1">
                   			<span class="required">*</span>
                             <span v-field-lbl="'isPermanent'" class="field">是否永久</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                   				<form-item ref="isPermanent" :field="{'defaultValue':null,'elementCanEdit':'{{canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：是\n1：否','elementReadonly':null,'elementType':'radio','emptyMessage':'请选择是否永久','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'是否永久','propName':'isPermanent','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.isPermanent','option':[{'value':'0','name':'是'},{'value':'1','name':'否'}]}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   	</tr>
                   	<tr>
                   		<td ref="tdlbl_到期日期" class="el-table__cell tdlbl tdw17" colspan="1">

                             <span v-field-lbl="'expiryDate'" class="field">到期日期</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                            <form-item ref="expiryDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'出生年月','propName':'expiryDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'expiryDate','iconName':'rqxzk','model':'vo.expiryDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   		<td ref="tdlbl_证书文件" class="el-table__cell tdlbl tdw17" colspan="1">

                             <span v-field-lbl="'certificateFile'" class="field">证书文件</span>
                         </td>
                   		<td class="el-table__cell tdcont tdw33" colspan="2">
                   				<form-item ref="certificateFile" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':70,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'textarea','emptyMessage':'请输入证书文件','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'证书文件','propName':'certificateFile','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.certificateFile','option':[]}" :vo="vo" :can-edit="canEdit" />
                         </td>
                   	</tr>
                   </tbody>
                 </table>
               </div>
             </div>
          </el-form>

        <div slot="footer" class="dialog-footer">
              <el-button type=" " icon="el-icon-close" @click="dialogFormVisible=false">关 闭</el-button>
              <el-button type="primary" icon="el-icon-check" @click="handleSubmit">保 存</el-button>
            </div>
        </el-dialog>

      <inner-table id="innerTableCertificate" ref="certificateList" :listviewurl="'teacher.certificate.list?urlsearch=teacherBasicInfoId:'+teacherPara.id" :can-edit="1" :can-delete="1" :link-prop-name="''" />

  </div>
</template>

<script>
const moment = require('moment')
export default {
    props: {
        list: [],
        teacherPara: {}
    },
    data() {
        return {
            vo: {},
            typeOption: [{'value': '0', 'name': '职业资格证书'}, {'value': '1', 'name': '信息技术服务管理认证'}, {'value': '2', 'name': '信息安全管理认证'}, {'value': '3', 'name': '计算机软件技术资格证书'}, {'value': '4', 'name': '专业技能证书'}, {'value': '5', 'name': '学历证书'}, {'value': '6', 'name': '外语水平证书'}, {'value': '7', 'name': '项目管理专业认证'}, {'value': '8', 'name': '企业内部培训证书'}, {'value': '9', 'name': '其他专业认证'}],
            tableData: [{
                relationship: '',
                familyMemberName: '',
                birthDate: '',
                familyIdCard: '',
                politicalStatus: '',
                workUnitAndPosition: ''
            }],
            form: {
                relationship: '',
                familyMemberName: '',
                birthDate: '',
                familyIdCard: '',
                politicalStatus: '',
                workUnitAndPosition: ''
            },
            dialogFormVisible: false
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
        let _this = this
        for (let i = 0; i < 3; i++) {
            _this.tableData.push(_this.form)
        }
        //this.tableData = this.list
    },
    methods: {
        onInnerTableListDataBeforeLoad($scope, qparams) {
            //qparams.urlsearch = `teacher.familyMembers.list?urlsearch=teacherId:${this.teacherPara.teacherId}`
            qparams.urlsearch = `teacherBasicInfoId:${this.teacherPara.id}`
        },
        handleSubmit() {
            let _this = this
            this.vo.expiryDate = this.vo.expiryDate ? moment(this.vo.expiryDate).format('YYYY-MM-DD') : ''
            if (_this.vo.id) {
                _this.$http({
                	method: 'put',
                	url: '/xsgl/teacherCertificate/update',
                	data: _this.vo
                }).then(res => {
                	if (res.code === 'success') {
                		_this.$message.success(res.message)
                	} else {
                		_this.$message.error(res.message)
                	}
                    _this.dialogFormVisible = false
                    _this.form = {}
                    _this.$bus.emit('refreshListData')
                })
            } else {
                let data = {
                    ..._this.vo,
                    //id:this.vo.id?this.vo.id:null,
                    teacherBasicInfoId: _this.teacherPara.id
                    //teacherId: _this.teacherPara.teacherId,
                    //teacherName: _this.teacherPara.name,
                    //
                    //relationship: this.vo.name,
                    //familyMemberName: this.vo.name,
                    //familyIdCard: this.teacherPara.name,
                    //politicalStatus: this.vo.politicalStatus,
                    //workUnitAndPosition: this.vo.workUnitAndPosition,
                }
                _this.$http({
                	method: 'post',
                	url: '/xsgl/teacherCertificate/insert',
                	data: data
                }).then(res => {
                	if (res.code === 'success') {
                		_this.$message.success(res.message)
                	} else {
                		_this.$message.error(res.message)
                	}
                    _this.dialogFormVisible = false
                    _this.form = {}
                    _this.$bus.emit('refreshListData')
                })
            }
        },
        // 内嵌子表-表头按钮方法
        selectGroup(val) {
            console.log('val', val)
            if (val) {
                this.vo = {...val}
            }
            this.dialogFormVisible = true
        },
        addList: function() {
            let _this = this
            _this.$nextTick(() => {
                _this.tableData.push(_this.form)
            })
        },
        delectData(index) {
            console.log(index)
            let _this = this
            _this.tableData.splice(index, 1)
        }
    }
}
</script>

<style scoped>
.header {
    padding:6px 20px;
    background-color: #f2f5fb;
    font-size: 15px;
    font-weight: 500;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
}
</style>

